import axios from "axios"

export default{
    NarliFerryboat: {
        async Table(data){
            const response = await axios.post("/api/ferryboat/narli/table",data)
            return response 
        },
        async ByProcessType(data){
            const response = await axios.post("/api/ferryboat/narli/totalstatsbyprocesstype",data)
            return response 
        },
        async ByVehicleType(data){
            const response = await axios.post("/api/ferryboat/narli/bydailyvehicletypestats",data)
            return response 
        },
        async ByPlate(data){
            const response = await axios.post("/api/ferryboat/narli/byvehicleplatestats",data)
            return response 
        },
        async TableSummary(data){
            const response = await axios.post("/api/ferryboat/narli/ferryboattablesummarystats",data)
            return response 
        }
    },
    IsBankasiHGS:{
        async Table(data,start,end,isIgnored){
            const response = await axios.post(`/api/hgs/isbankasi/table/${start}/${end}/${isIgnored}`,data)
            return response 
        },
        async ChargeTable(data,start,end){
            const response = await axios.post(`/api/hgs/isbankasi/table/charge/${start}/${end}`,data)
            return response 
        },
        async ExcelExport(start,end,param){
            const response = await axios.get(`/api/hgs/isbankasi/excelexportbetweendatesdata?StartDate=${start}&EndDate=${end}&SearchParam=${param}`,{responseType: 'blob',})
            return response
        },
        async ExcelExportCharge(start,end,param){
            const response = await axios.get(`/api/hgs/isbankasi/charge/excelexportbetweendatesdata?StartDate=${start}&EndDate=${end}&SearchParam=${param}`,{responseType: 'blob',})
            return response
        },
        async StatsTransactionByBetweenDates(data){
            const response = await axios.post(`/api/hgs/isbankasi/stats/transactionbybetweendates`,data)
            return response 
        },
        async StatsChargeCanceled(data){
            const response = await axios.post(`/api/hgs/isbankasi/stats/chargecanceled`,data)
            return response 
        },
        async StatsCharge(data){
            const response = await axios.post(`/api/hgs/isbankasi/stats/charge`,data)
            return response 
        },
    }
}